import React from 'react';
import { useTranslation } from 'react-i18next';

import { Grid } from '@material-ui/core';

import DetailsItem from 'components/Tools/DetailsItem';
import PageMode from 'components/Tools/PageMode';

import CollectTable from './CollectTable';

import { ICollectTableProps } from '../../types';

const CollectDetailTable: React.FC<ICollectTableProps> = ({
  isOpen,
  address,
  collectData,
  handleClose,
}) => {
  const { t } = useTranslation();

  return (
    <PageMode
      isModal
      disableSubmit
      open={isOpen}
      handleClose={() => handleClose()}
      title="Detalhe Reserva"
    >
      <>
        <div className="wrapper">
          <div className="contentDetail">
            <Grid container spacing={3} className="detailHeader">
              <div className="details">
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '25px',
                  }}
                >
                  <div className="detailsItemsContainer" id="firstRow">
                    <DetailsItem
                      title={String(t('screens.reportsStock.address'))}
                      value={String(address?.descricaoEndereco || '')}
                    />
                    {address?.descricaoCaixa && (
                      <DetailsItem
                        title={String(t('screens.commom.box'))}
                        value={address?.descricaoCaixa || ''}
                      />
                    )}
                    <DetailsItem
                      title={String(t('screens.commom.product'))}
                      value={address?.produto || ''}
                    />
                    <DetailsItem
                      title={`${t('screens.followWave.amountOrder')}`}
                      value={String(collectData.length) || ''}
                    />
                    {address?.cor && (
                      <DetailsItem
                        title={String(t('screens.commom.color'))}
                        value={address?.cor || ''}
                      />
                    )}
                    {address?.tamanho && (
                      <DetailsItem
                        title={String(t('screens.commom.size'))}
                        value={address?.tamanho || ''}
                      />
                    )}
                    {address?.grade && (
                      <DetailsItem
                        title={String(t('screens.commom.grid'))}
                        value={address?.grade || ''}
                      />
                    )}
                  </div>
                </div>
              </div>
            </Grid>
          </div>
        </div>
        <CollectTable collectData={collectData} />
      </>
    </PageMode>
  );
};
export default CollectDetailTable;
